function isToastMaster(obj) {
  return !!obj.addEventListener && !!obj.addToast;
}
export {
  isToastMaster
};
//# sourceMappingURL=utils.js.map
